/**
 * Composite case id (`<study_uid>::<job_id>`) — the worklist row key and the
 * /case-viewer route param for reader/reviewer cohorts. `job_id` is required on
 * a reader study, so this always carries the suffix (unlike the labeling
 * worklist's `studyRowId`, where job_id is optional). Single source of truth
 * for the call sites that otherwise hand-build the same template.
 *
 * Pure leaf helper — intentionally NOT in useStudyQueries, which component
 * tests fully `vi.mock` (it transitively imports Cornerstone); a runtime export
 * there would be undefined under those mocks.
 */
export function readerCaseId(study: { study_uid: string; job_id: string }): string {
  return `${study.study_uid}::${study.job_id}`;
}

/** Build a case-viewer route without losing reader or collection identity. */
export function readerCaseViewerPath(
  studyId: string,
  cohortId?: string | null,
  collectionId?: string | null,
): string {
  const params = new URLSearchParams();
  if (cohortId) params.set("cohort", cohortId);
  if (collectionId && collectionId !== "__saved__") params.set("collection", collectionId);
  const query = params.toString();
  return `/case-viewer/${studyId}${query ? `?${query}` : ""}`;
}
